import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = (type = "consumer") => {
  return APIHost() + `:3005${type === "consumer" ? "/consumer" : ""}`;
};

export const getConsumerDetails = () => {
  return axios.get(`${baseURL()}`);
};

// Profile Details
export const uploadConsumerProfileImg = (data) => {
  const url = `${baseURL()}/uplProfile`;
  return axios.post(url, data);
};

export const changePhoneNoUpdate = (data) => {
  const url = `${baseURL()}/updatePhone`;
  return axios.post(url, data);
};

export const updateConsumer = (data) => {
  const url = `${baseURL()}/Update`;
  return axios.post(url, data);
};

export const verifyAccount = (data) => {
  const url = `${baseURL()}/checkPassword`;
  return axios.post(url, data);
};

// Address
export const getConsumerAddress = () => {
  const url = `${baseURL()}/getAddr`;
  return axios.get(url);
};

export const addConsumerAddress = (params) => {
  const url = `${baseURL()}/addAddr`;
  return axios.post(url, params);
};

export const updateConsumerAddress = (params) => {
  const url = `${baseURL()}/editAddr`;
  return axios.post(url, params);
};

export const deleteConsumerAddress = (params) => {
  const url = `${baseURL()}/delAddr`;
  return axios.post(url, params);
};

// Change Password
export const changePassword = (params) => {
  const url = `${baseURL()}/changePass`;
  return axios.post(url, params);
};

// Notification Settings
export const setupNotifcation = (params) => {
  const url = `${baseURL()}/setUpNotification`;
  return axios.post(url, params);
};

// Wallet Pin
export const setWalletPin = (params) => {
  const url = `${baseURL()}/walletPin`;
  return axios.post(url, params);
};

// Become Merchant
export const submitBecomeMerchant = (params) => {
  const url = `${baseURL("other")}/business/becomeMerchant`;
  return axios.post(url, params, {
    timeout: 60000,
  });
};

// Become Merchant V2
export const submitBecomeMerchant_Two = (params) => {
  const url = `${baseURL("other")}/business/becomeMerchantV2`;
  return axios.post(url, params, {
    timeout: 60000,
  });
};
export const getBusinessDetail = (case_id) => {
  const url = `${baseURL("other")}/business/business_details/${case_id}`;
  return axios.get(url);
};
// Food Preference
export const setProductPreference = (params) => {
  const url = `${baseURL("other")}/setFoodPerf`;
  return axios.post(url, params);
};

// Whatsapp
export const getWhatsApp = () => {
  const url = `${baseURL("other")}/getLololContact/whatsapp`;
  return axios.get(url);
};

// Hotline
export const getPhoneNumber = () => {
  const url = `${baseURL("other")}/getLololContact/phone`;
  return axios.get(url);
};
